declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const dataLayerPush = (data: unknown) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};

export const updateConsent = (consentData: Record<string, unknown>) => {
  if (typeof window !== "undefined") {
    // Use gtag for consent (needed for proper Google Consent Mode)
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", consentData);
    }

    // Also push to dataLayer for debugging
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "consent_update",
      ...consentData,
    });
  }
};

// Note: Default consent is now set in gatsby-browser.js before GTM loads
